// extracted by mini-css-extract-plugin
export default {"callBtn":"AdminMobileOrderStorePhoneNo_callBtn__FVMOL","callIcon":"AdminMobileOrderStorePhoneNo_callIcon__jF6tf"};